<div class="container p-4" style="max-width: 1200px; margin: auto;">
  <h2 class="mb-4">Import Results</h2>
  <div class="d-flex justify-content-between">
    <!-- Left Side (Form Fields) -->
    <div class="form-section" style="flex: 1; padding-right: 20px;">
      <mat-form-field appearance="outline" class="w-100 mb-3">
        <mat-label>Select Course</mat-label>
        <mat-select [(ngModel)]="selectedCourseId" (ngModelChange)="onCourseChange($event)">
          <mat-option *ngFor="let course of courseList" [value]="course.id">
            {{ course.name }}-{{course.crs_code}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100 mb-3">
        <mat-label>Select Semester</mat-label>
        <mat-select [(ngModel)]="selectedSemester">
          <mat-option *ngFor="let sem of semesterList" [value]="sem.number">
            Semester {{ sem.number }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100 mb-3">
        <mat-label>Select Result Type</mat-label>
        <mat-select [(ngModel)]="resultType" name="resultType">
          <mat-option value="regular">Regular</mat-option>
          <mat-option value="iti">ITI</mat-option>
          <mat-option value="puc">PUC</mat-option>
          <mat-option value="COB">COB</mat-option>
        </mat-select>
      </mat-form-field>

      <div class="row">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Select Exam Month</mat-label>
          <mat-select [(ngModel)]="examMonth" name="examMonth">
            <mat-option *ngFor="let month of months" [value]="month.months_name">
              {{ month.months_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Select Exam Year</mat-label>
          <mat-select  [(ngModel)]="examYear" name="examYear">
            <mat-option *ngFor="let year of years" [value]="year.year_name">
              {{ year.year_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <input #fileInput type="file" accept=".xlsx, .xls" (change)="onFileChange($event)" class="mb-3">
    </div>

    <!-- Right Side (Summary) -->
    <div class="summary-section" style="flex: 1; padding-left: 20px;">
      <div *ngIf="resultSummary?.length > 0" class="mt-6">
        <h3 class="text-md font-semibold mb-3">Result Summary</h3>

        <div class="overflow-auto">
          <table mat-table [dataSource]="resultSummary" class="mat-elevation-z2 w-full min-w-[600px]">
            
            <!-- Month -->
            <ng-container matColumnDef="exam_month">
              <th mat-header-cell *matHeaderCellDef> Month </th>
              <td mat-cell *matCellDef="let row"> {{ row.exam_month }} </td>
            </ng-container>

            <!-- Year -->
            <ng-container matColumnDef="exam_year">
              <th mat-header-cell *matHeaderCellDef> Year </th>
              <td mat-cell *matCellDef="let row"> {{ row.exam_year }} </td>
            </ng-container>

            <ng-container matColumnDef="semester_number">
              <th mat-header-cell *matHeaderCellDef> Semester </th>
              <td mat-cell *matCellDef="let row"> {{ row.semester_number }} </td>
            </ng-container>

            <!-- Result Type -->
            <ng-container matColumnDef="result_type">
              <th mat-header-cell *matHeaderCellDef> Result Type </th>
              <td mat-cell *matCellDef="let row"> {{ row.result_type }} </td>
            </ng-container>

            <!-- Count -->
            <ng-container matColumnDef="count">
              <th mat-header-cell *matHeaderCellDef> Count </th>
              <td mat-cell *matCellDef="let row"> {{ row.count }} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="summaryDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: summaryDisplayedColumns;"></tr>
          </table>
        </div>
      </div>

  
    </div>
  </div>

  <div *ngIf="columnHeaders.length > 0" class="mb-4">
    <h4>Map Excel Columns</h4>
    <div *ngFor="let col of columnHeaders" class="mb-2">
      <strong>{{ col }}</strong>
      <mat-form-field class="w-50 ms-3" appearance="fill">
        <mat-label>Map to</mat-label>
        <mat-select [(ngModel)]="columnMapping[col]">
          <mat-option [value]="''">-- Ignore --</mat-option>
          <mat-option *ngFor="let field of getAvailableFields(col)" [value]="field">
            {{ field }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <!-- Other Sections like Validation Errors, Excel Preview, etc. -->
  <div *ngIf="excelData.length > 0" class="mt-4">
    <h4>Excel Data Preview</h4>
    <div class="table-responsive">
      <table class="table table-bordered table-sm">
        <thead class="table-light">
          <tr>
            <th *ngFor="let col of columnHeaders">{{ col }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of excelData | slice:0:5">
            <td *ngFor="let col of columnHeaders">
              {{ row[col] }}
            </td>
          </tr>
        </tbody>
      </table>
      <p class="text-muted">Showing first 5 rows</p>
    </div>
  </div>

  <div *ngIf="invalidRows.length > 0" class="mb-3 text-danger">
    <h4>Validation Errors:</h4>
    <ul>
      <li *ngFor="let error of invalidRows">{{ error }}</li>
    </ul>
  </div>

  <div class="d-flex gap-3 mt-3">
    <button mat-raised-button color="primary" (click)="importResults()">Import</button>
    <button mat-raised-button color="primary" (click)="replaceResults()">Delete & Import</button>
    <button mat-button color="warn" (click)="reset()">Reset</button>
  </div>
  <h6>Note: Delete and Import: Use this only when major changes are there in the excel sheet data</h6>
    <h6>Note: Import: Use this when previous empty columns to be updated (Keep other columns intact)</h6>

  <div *ngIf="importSummary" class="mt-4">
    <h4>Import Summary:</h4>
    <pre>{{ importSummary | json }}</pre>
  </div>

  <div *ngIf="importSkipped.length > 0" class="mt-3">
    <h4>Skipped Entries:</h4>
    <pre>{{ importSkipped | json }}</pre>
  </div>

  <div *ngIf="invalidRows.length > 0" class="mt-3">
    <h4>Invalid Entries:</h4>
    <pre>{{ invalidRows | json }}</pre>
  </div>
</div>
